/* eslint-disable max-len */
import React from 'react';

interface IWrongProps {
    color?: string;
}

const Wrong: React.FC<IWrongProps> = ({color = '#F44336'}) => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C10.1217 0 12.1569 0.842489 13.6572 2.34277C15.1574 3.84306 16 5.87827 16 8C16 10.1217 15.1574 12.1569 13.6572 13.6572C12.1569 15.1574 10.1217 16 8 16C5.87827 16 3.84306 15.1574 2.34277 13.6572C0.842489 12.1569 0 10.1217 0 8C0 5.87827 0.842473 3.84306 2.34277 2.34277C3.84306 0.842473 5.87827 0 8 0ZM10.4766 4.52539C10.2114 4.52539 9.95706 4.63087 9.76953 4.81836L8 6.58691L6.23047 4.81836C6.04294 4.63087 5.78862 4.52539 5.52344 4.52539C5.25828 4.52543 5.0039 4.63086 4.81641 4.81836C4.62892 5.00589 4.52344 5.26021 4.52344 5.52539C4.52344 5.79057 4.62892 6.04489 4.81641 6.23242L6.58594 8.00195L4.81934 9.76855C4.63207 9.95609 4.55567 10.2389 4.55566 10.5039C4.55567 10.7691 4.63186 10.9951 4.81934 11.1826C5.00676 11.37 5.26131 11.4755 5.52637 11.4756C5.79158 11.4756 6.04684 11.3702 6.23438 11.1826L8 9.41602L9.7666 11.1826C9.95414 11.3699 10.2369 11.4463 10.502 11.4463C10.7671 11.4463 10.9931 11.3701 11.1807 11.1826C11.3681 10.9952 11.4735 10.7406 11.4736 10.4756C11.4736 10.2104 11.3682 9.95511 11.1807 9.76758L9.41406 8.00098L11.1836 6.23242C11.3711 6.04489 11.4766 5.79057 11.4766 5.52539C11.4765 5.26023 11.3711 5.00586 11.1836 4.81836C10.9961 4.63088 10.7417 4.52539 10.4766 4.52539Z"
                fill={color}
            />
        </svg>
    );

};

export default Wrong;